import Vue from "vue";
import Router from "vue-router";
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/error/401",
    component: () => import("@/views/error/401"),
    hidden: true
  },
  {
    path: "/error/404",
    component: () => import("@/views/error/404"),
    hidden: true
  },
  {
    path: "",
    component: Layout,
    name: "",
    // hidden: true,
    children: [
      {
        path: "/",
        name: "Dashboard",
        meta: { title: "首页", icon: "dashboard", affix: true },
        component: () => import("@/views/dashboard/index")
      }
    ]
  },
  {
    path: "",
    component: Layout,
    name: "Info",
    hidden: true,
    children: [
      {
        path: "/info",
        component: () => import("@/views/info/index")
      }
    ]
  },
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index")
      }
    ]
  }
];

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: "history",
  routes: constantRouterMap
});

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "System",
    meta: { title: "套餐管理", permissions: ["admin", "role"], icon: "system" },
    children: [
      {
        path: "/product/list",
        name: "productList",
        component: () => import("@/views/product/productList"),
        meta: { title: "套餐&路线", permissions: ["admin"] }
      }
      ,
      {
        path: "/product/store",
        name: "ProductStore",
        hidden:true,
        component: () => import("@/views/product/store"),
        meta: { title: "套餐新增修改", permissions: ["admin"] }
      }
    ]
  },
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Order",
    meta: {
      title: "订单管理",
      permissions: ["banner"],
      icon: "content"
    },
    children: [
      {
        path: "/orderList",
        name: "ShopList",
        component: () => import("@/views/order/index"),
        meta: { title: "订单列表", permissions: ["banner"] }
      },
      {
        path: "/order/viewDetails",
        name: "viewDetails",
        hidden:true,
        component: () => import("@/views/order/viewDetails"),
        meta: { title: "查看详情", permissions: ["admin"] }
      },
      {
        path: "/order/checkAfterSales",
        name: "checkAfterSales",
        hidden:true,
        component: () => import("@/views/order/checkAfterSales"),
        meta: { title: "查看售后", permissions: ["admin"] }
      },
      {
        path: "/subscribeList",
        name: "SubscribeList",
        component: () => import("@/views/order/subscribeList"),
        meta: { title: "预约列表", permissions: ["banner"] }
      }

    ]
  },

  // {
  //   path: "",
  //   component: Layout,
  //   alwaysShow: true,
  //   name: "User",
  //   meta: { title: "用户管理", permissions: ["user"], icon: "users" },
  //   children: [
  //     {
  //       path: "/user/list",
  //       name: "Users",
  //       component: () => import("@/views/user/index"),
  //       meta: { title: "用户列表", permissions: ["user"] }
  //     }
  //   ]
  // },
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Shop",
    meta: {
      title: "店铺管理(酒店管理)",
      permissions: ["banner"],
      icon: "content"
    },
    children: [
      {
        path: "shopChange",
        name: "ShopChange",
        component: () => import("@/views/shop/index"),
        meta: { title: "修改资料", permissions: ["banner"] }
      }
    ]
  },

  // {
  //   path: "",
  //   component: Layout,
  //   alwaysShow: true,
  //   name: "Content",
  //   meta: {
  //     title: "内容管理",
  //     permissions: ["banner", "about"],
  //     icon: "content"
  //   },
  //   children: [
  //     {
  //       path: "/banner/list",
  //       name: "Banners",
  //       component: () => import("@/views/banner/index"),
  //       meta: { title: "轮播图设置", permissions: ["banner"] }
  //     },
  //     {
  //       path: "/about",
  //       name: "About",
  //       component: () => import("@/views/about/index"),
  //       meta: { title: "关于我们", permissions: ["about"] }
  //     }
  //   ]
  // },

  {
    path: "/finance",
    name: "finance",
    component: Layout,
    alwaysShow: true,
    redirect: "/finance/index",
    meta: { title: "财务管理", icon: "example" },
    children: [
      {
        path: "index",
        name: "financeList",
        component: () => import("@/views/finance/index"),
        meta: { title: "财务统计" }
      },
      {
        path: "shopWithdraw",
        name: "shopWithdraw",
        component: () => import("@/views/finance/shopWithdraw"),
        meta: { title: "店铺提现" }
      },{
        path: "cashout",
        name: "cashout",
        hidden: true,
        component: () => import("@/views/finance/cashout"),
        meta: { title: "提现" }
      },
    ]
  },
  { path: "*", redirect: "/error/404", hidden: true }
];
